/**
 * --- Mobile Menu Functions ---
 * This code manages the behavior of the mobile navigation menu, including toggling visibility of main and side menus.
 */

$(document).ready(function () {
    mainMenuButton();
    sideMenuButton();
});

$(window).on('scroll', function () {
})

$(window).on('resize', function () {
    closeMenu();
});

$(window).on('orientationchange', function () {
    closeMenu();
});

// initialise mobile menu functions
function mobileMenu() {
    if (isMobile) {
        mainMenuButton();
        sideMenuButton();
    }
}

// main menu button toggle
function mainMenuButton() {
    $(".main-menu-button").off('click').on('click', function () { toggleMainAction(); });
    var mainIsToggling = false;
    function toggleMainAction() {
        if (!$(".main-menu-button").is(":visible")) { return };
        if (mainIsToggling) { return }
        mainIsToggling = true;
        $(".side-menu-items, .side-menu-button").removeClass('active');
        $('.main-menu-button').toggleClass('active');
        $(".main-menu-items").toggleClass('active').promise().done(function () {
            mainIsToggling = false
        });
        if ($(".main-menu-items").hasClass("active")) {
            var menuTop = $('.main-menu-items').offset().top;
            window.scroll(0, menuTop);
        }
    }
}

// side menu button toggle
function sideMenuButton() {
    $(".side-menu-button").off('click').on('click', function () { toggleSideAction(); });
    var sideIsToggling = false;
    function toggleSideAction() {
        if (!$(".side-menu-button").is(":visible")) { return };
        if (sideIsToggling) { return }
        sideIsToggling = true;
        $(".main-menu-items, .main-menu-button").removeClass('active');
        $('.side-menu-button').toggleClass('active');
        $(".side-menu-items").toggleClass('active').promise().done(function () { sideIsToggling = false });
        if ($(".side-menu-items").hasClass("active")) {
            var menuTop = $('.side-menu-items').offset().top;
            window.scroll(0, menuTop);
        }
    }
}

function closeMenu() {
    if ($(".main-menu-button").is(":visible") && $(".main-menu-items").is(":visible")) {
        $('.main-menu-button, .side-menu-button').removeClass('active');
        $(".main-menu-items, .side-menu-items").removeClass('active').promise().done(function () { isToggling = false });
    };
}
